import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { ResultWizardStep } from '@app/common/components/configurable-wizards/ResultWizardStep/ResultWizardStep';

import { PageURL } from '@app/core/widgets/pages';

import { useUserLoginTranslation } from '@app/widgets/user-login/hooks/useUserLoginTranslation';

import { QuickLoginSetupMode, QuickLoginSetupState } from '../../constants';
import { QuickLoginSetup } from './fields/QuickLoginSetup';

import styles from './QuickLoginSetupWizardStep.pcss';

export const QuickLoginSetupWizardStep: React.FC = () => {
  const { t } = useUserLoginTranslation();
  const location = useLocation<QuickLoginSetupState>();
  const setupMode = location.state?.setupMode || QuickLoginSetupMode.InstallationRequired;
  const history = useHistory();

  const title = setupMode === QuickLoginSetupMode.InstallationRequired
    ? t('login.steps.quick-login.setup.installation-required.title|Quick Login Setup installation required title', 'Biometric login setup')
    : t('login.steps.quick-login.setup.biometric-required.title|Quick Login Setup biometric required title', 'Let\'s complete biometric login setup');

  const buttonTitle = t('login.steps.quick-login.status.button.title|Cancel login & return to login button text', 'Return to login');

  return (
    <ResultWizardStep
      contentClassName={styles.container}
      buttonClassName={styles.button}
      wizardStepSize="large"
      title={title}
      level="support"
      buttonText={buttonTitle}
        // eslint-disable-next-line i18next/no-literal-string
      buttonStableName="ReturnToLoginButton"
      handleButtonClick={() => {
        history.replace(`${PageURL.USER_LOGIN}`);
        return true;
      }}
    >
      <QuickLoginSetup setupMode={setupMode} />
    </ResultWizardStep>
  );
};
